var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25586",
    "data-name": "Grupo 25586",
    transform: "translate(-1693 -274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25483",
    "data-name": "Grupo 25483",
    transform: "translate(1693.008 274.496)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2133",
    "data-name": "Elipse 2133",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(-0.007 -0.496)",
    fill: "#e5f4f7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_64456",
    "data-name": "Trazado 64456",
    d: "M429.949,544.476a.927.927,0,0,1,1.31-1.31,2.221,2.221,0,0,0,3.068,0l3.081-3.081a2.169,2.169,0,0,0-3.03-3.1l-.038.038a.926.926,0,0,1-1.309-1.31,4.022,4.022,0,0,1,5.688,5.688l-3.081,3.081a4.027,4.027,0,0,1-5.688,0Zm-.855,4.876a4.011,4.011,0,0,0,2.844-1.176.927.927,0,0,0-1.31-1.31,2.169,2.169,0,0,1-3.1-3.03l.037-.038,3.064-3.064a2.17,2.17,0,0,1,3.067,0,.928.928,0,0,0,1.313-1.312,4.026,4.026,0,0,0-5.688,0l-3.065,3.064a4.02,4.02,0,0,0,2.844,6.865Z",
    transform: "translate(1275.524 -252.848)",
    fill: "#0099b7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoLink);
export default __webpack_public_path__ + "static/media/Icono-Link.d6c2096e99db0bff167efbdb60f2143b.svg";
export { ForwardRef as ReactComponent };